<template>
  <el-dialog :visible.sync="uploadMediaModalShow" width="30%" @closed="$emit('close');" v-loading="loading">
    <div class="row" slot="title">
      <div class="col-12">
        <h4 class="m-0">Upload file</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <el-upload action :file-list="fileList" :on-change="handleUpload" :on-exceed="handleExceed" :limit="1" drag
          :auto-upload="false" accept="application/pdf,image/png,image/jpg,image/jpeg">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">Only accepting PDF file</div>
        </el-upload>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-between w-100 mt-3">
      <el-button class="btn-secondary" @click="$emit('close');">Cancel</el-button>
      <el-button class="btn-primary" @click="onSubmit">Send</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Media from '../frontend/modelsPortal/common/Media.js'
export default {
  props: {
    collectionData: {
      type: Object,
    },
  },
  data() {
    return {
      fileList: [],
      loading: false,
      uploadMediaModalShow: true,
    };
  },
  mounted() {

  },
  methods: {
    onSubmit() {
      let data = this.collectionData;
      data.file = this.fileList[0].raw;

      new Media(data)
        .save()
        .then((result) => {
          this.$emit('refresh');
        }).catch((err) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong."
          });
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`You can only upload one file`);
    },
    // this one will request the ocr scanner
    async uploadInvoice() {
      try {
        if (this.fileList.length === 0) return;

        this.loading = true;

      } catch (err) {
        this.$message.error(err.message);
      } finally {
        this.loading = false;
      }
    },
    handleUpload(file) {
      //   all file uploaded here will be assumed to be an invoice
      file.collection_name = "invoice";

      this.fileList.push(file);
    },
    onDelete(index) {
      this.fileList.splice(index, 1);
    },
  }
};
</script>